var $sampleRemoveButtonClicked;

jQuery.event.special.touchstart = {
	setup: function( _, ns, handle ) {
		this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
	}
};
jQuery.event.special.touchmove = {
	setup: function( _, ns, handle ) {
		this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
	}
};

jQuery(document).ready(function() {
	if (jQuery('.slideshow .owl-carousel .col-img').length > 1) {
		jQuery('.slideshow .owl-carousel').owlCarousel({
			items: 1,
			loop: false,
			nav: true,
			dots: true,
			autoplay: true,
			autoplayTimeout: 6000,
			autoplayHoverPause: true,
			autoplaySpeed: 3000,
			navSpeed: 3000,
			animateOut: 'fadeOut',
			navText: ['<span class="arrow-circle arrow-left-circle"></span>', '<span class="arrow-circle arrow-right-circle"></span>'],
			onInitialized: function(event) {
				owl_control = jQuery(event.currentTarget).append('<div class="owl-control"></div>').find('.owl-control');
				jQuery(event.currentTarget).find('.owl-dots,.owl-nav').appendTo(owl_control);
			}
		});
	}

	if (jQuery('.feature-collection-carousel .owl-carousel').length) {
		jQuery('.feature-collection-carousel .owl-carousel').owlCarousel({
			loop: true,
			nav: true,
			dots: true,
			autoplay: true,
			autoplayTimeout: 6000,
			autoplayHoverPause: true,
			autoplaySpeed: 3000,
			navSpeed: 3000,
			navText: ['<span class="arrow-circle arrow-left-circle"></span>', '<span class="arrow-circle arrow-right-circle"></span>'],
			responsive: {
				0: {
					items: 1,
				},
				769: {
					items: 3,
				},
				1281: {
					items: 4,
				}
			}
		});
	}

	$( "body" ).on( "click", ".sampleButtonOverride", function(e) {
		if(e) {
			e.preventDefault();
		}
		$sampleRemoveButtonClicked = $(this).parents('.deleteButtonWrapper').find('.cart__remove');
		$.featherlight($('#removeSamplesModal'), {'variant':'removeSamplesFeatherlight'});
	});

	$( "body" ).on( "click", ".btn--tertiary", function(e) {
		if(e) {
			e.preventDefault();
		}
		$.featherlight.close();
	});

	$( "body" ).on( "click", ".btn--primary", function(e) {
		if(e) {
			e.preventDefault();
		}
		$sampleRemoveButtonClicked.click();
		$.featherlight.close();
	});

	if( jQuery('.addtocart-question').length ){
		if( jQuery('.variant-wrapper').length ){
			jQuery('.addtocart-question').addClass('has-variant-wrapper').css('marginLeft', jQuery('.variant-wrapper').outerWidth() )
		}
	}

	if( jQuery('.addtocart-question').length ){
		if( jQuery('.variant-wrapper').length ){
			jQuery('.addtocart-question').addClass('has-variant-wrapper').css('marginLeft', jQuery('.variant-wrapper').outerWidth() )
		}
	}

	if( $('.product-item').length ) {
		$('.product-item').junoQuickBuy();
	}
});
